<template>
  <div class="user page-wrapper">
    <div class="header bg-color-red2 acea-row row-between-wrapper">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="pictrue user-right-margin"><img :src="userInfo.avatar" /></div>
        <div class="text" style="display: flex;">
          <div>
            <div class="acea-row row-middle">
              <div class="name line1">{{ userInfo.nickname }}</div>
              <div class="member acea-row row-middle" v-if="userInfo.vip">
                <img :src="userInfo.vip_icon" />{{ userInfo.vip_name }}
              </div>
            </div>
            余额：<span class="moneybalance">{{ userInfo.now_money || 0 }}</span>
          </div>
          <!-- <div class="outLogin" v-if="outType == 2" @click="logout">退出登录</div> -->
          <div class="outLogin" @click="logout">退出登录</div>
        </div>
      </div>
      <!-- <span
        class="iconfont icon-weizhi"
        @click="$router.push({ path: '/user/data' })"
        v-if="false"
      ></span>
      <span
        class="iconfont icon-weizhi"
        @click="$router.push({ path: '/user/add_manage' })"
      ></span> -->
      <div class="iconWeizhi" @click="$router.push({ path: '/user/add_manage' })">
        <Icon name="location-o" />
      </div>
    </div>
    <div class="ExchangeCertificate">
      <div class="userExchange">
        <div>我的兑换券</div>
        <div class="huanjuan">{{ couponsListLength }}<span>张</span></div>
      </div>
      <div class="viewNow">
        <Button type="danger" round size="small" @click="openZujian">立即查看</Button>
      </div>
    </div>
    <div class="wrapper">
      <div class="nav acea-row row-middle" v-if="false">
        <router-link :to="{ path: '/user/account' }" class="item">
          <div>我的点券</div>
          <div class="num">{{ userInfo.now_money || 0 }}</div>
        </router-link>
        <router-link :to="'/user/user_coupon'" class="item">
          <div>优惠券</div>
          <div class="num">{{ userInfo.couponCount || 0 }}</div>
        </router-link>
        <!--<router-link
          :to="'/user/user_promotion'"
          class="item"
          v-if="userInfo.is_promoter === 1 || userInfo.statu === 2"
        >
          <div>当前佣金</div>
          <div class="num">{{ userInfo.brokerage_price || 0 }}</div>
        </router-link>-->
        <!--<router-link :to="'/user/integral'" class="item" v-else>
          <div>当前积分</div>
          <div class="num">{{ userInfo.integral || 0 }}</div>
        </router-link>
        <router-link :to="'/user/user_coupon'" class="item">
          <div>优惠券</div>
          <div class="num">{{ userInfo.couponCount || 0 }}</div>
        </router-link>-->
      </div>
      <div class="myOrder">
        <div class="title acea-row row-between-wrapper">
          <div>商城订单 </div>
          <router-link
            :to="{ path: '/order/list/', query: $route.query.festivalName ? { 'festivalName': $route.query.festivalName } : {} }"
            class="allOrder">
            全部订单<span class="iconfont icon-jiantou"></span>
          </router-link>
        </div>
        <div class="orderState acea-row row-middle">
          <router-link
            :to="{ path: '/order/list/' + 0, query: $route.query.festivalName ? { 'festivalName': $route.query.festivalName } : {} }"
            class="item">
            <div class="pictrue">
              <img src="@assets/images/kabao.png" />
              <span class="order-status-num" v-if="orderStatusNum.unpaid_count > 0">{{ orderStatusNum.unpaid_count
              }}</span>
            </div>
            <div>待付款</div>
          </router-link>
          <router-link
            :to="{ path: '/order/list/' + 1, query: $route.query.festivalName ? { 'festivalName': $route.query.festivalName } : {} }"
            class="item">
            <div class="pictrue">
              <img src="@assets/images/daka.png" />
              <span class="order-status-num" v-if="orderStatusNum.unshipped_count > 0">{{ orderStatusNum.unshipped_count
              }}</span>
            </div>
            <div>已付款</div>
          </router-link>
          <router-link
            :to="{ path: '/order/list/' + 2, query: $route.query.festivalName ? { 'festivalName': $route.query.festivalName } : {} }"
            class="item">
            <div class="pictrue">
              <img src="@assets/images/daishouhuo.png" />
              <span class="order-status-num" v-if="orderStatusNum.received_count > 0">{{ orderStatusNum.received_count
              }}</span>
            </div>
            <div>已发货</div>
          </router-link>
          <router-link
            :to="{ path: '/order/list/' + 3, query: $route.query.festivalName ? { 'festivalName': $route.query.festivalName } : {} }"
            class="item" v-if="false">
            <div class="pictrue">
              <img src="@assets/images/dpj.png" />
              <span class="order-status-num" v-if="orderStatusNum.evaluated_count > 0">{{ orderStatusNum.evaluated_count
              }}</span>
            </div>
            <div>待评价</div>
          </router-link>
          <router-link
            :to="{ path: '/order/refund_list', query: $route.query.festivalName ? { 'festivalName': $route.query.festivalName } : {} }"
            class="item" v-if="true">
            <div class="pictrue">
              <img src="@assets/images/tuikuan.png" />
              <span class="order-status-num" v-if="orderStatusNum.refund_count > 0">{{ orderStatusNum.refund_count
              }}</span>
            </div>
            <div>售后/退款</div>
          </router-link>
        </div>
      </div>

      <div class="myService" v-if="false">
        <div class="title acea-row row-middle">我的服务</div>
        <div class="serviceList acea-row row-middle">
          <template v-for="(item, index) in MyMenus">
            <div class="item" :key="index" @click="goPages(index)" v-if="item.wap_url">
              <div class="pictrue">
                <img :src="item.pic" />
              </div>
              <div>{{ item.name }}</div>
            </div>
          </template>
          <!--<div-->
          <!--class="item"-->
          <!--@click="changeswitch(true)"-->
          <!--v-if="userInfo.phone && isWeixin"-->
          <!--&gt;-->
          <!--<div class="pictrue"><img src="@assets/images/switch.png" /></div>-->
          <!--<div>账号切换</div>-->
          <!--</div>-->
        </div>
      </div>

      <!-- 电影 -->
      <UserOrder v-if="!$route.query.festivalName" :OrderInfo="movieOrderInfo" :key="'movie'"></UserOrder>
      <!-- 门票订单 -->
      <UserOrder v-if="!$route.query.festivalName" :OrderInfo="ticketOrderInfo" :key="'ticket'"></UserOrder>
      <!-- 蛋糕订单 -->
      <UserOrder v-if="!$route.query.festivalName" :OrderInfo='cakeOrderInfo' :key="'cake'"></UserOrder>
       <!-- 演出订单 -->
       <UserOrder v-if="!$route.query.festivalName" :OrderInfo='xkycOrderInfo' :key="'xkyc'"></UserOrder>
      <!-- 礼品卡提货券 -->
      <div class="myService">
        <!-- 旧我的点劵 -->
        <!-- <div class="title acea-row row-between-wrapper">
        <div>我的兑换券({{couponsListLength}}张)</div>
        <div class="allOrder" @click="openZujian">
          <span class="iconfont icon-jiantou"></span>
        </div>
      </div> -->

        <!-- 	  <div class="title acea-row row-between-wrapper">
	    <div>扫一扫</div>
	    <div class="allOrder" @click="scanQrcode">
	      <span class="iconfont icon-jiantou"></span>
	    </div>
	  </div> -->
        <!-- <div class="title acea-row row-middle"></div>
             <router-link :to="'/order/list/'" class="allOrder">
            全部订单<span class="iconfont icon-jiantou"></span>
          </router-link> -->
      </div>

    </div>

    <!--<img src="@assets/images/support.png" class="support" />-->
    <div class="footer-line-height" v-if="false"></div>

    <SwitchWindow v-on:changeswitch="changeswitch" :switchActive="switchActive" :login_type="userInfo.login_type">
    </SwitchWindow>

    <ProductCouponWindow v-on:changeFun="changeFun" :attr="attr" :useCoupon='useCoupon' :dontUse='dontUse' :bindStatus='bindStatus' :uStatus="uStatus">
    </ProductCouponWindow>
    <!-- <div
      class="logOut cart-color acea-row row-center-wrapper logoutbtn"
      @click="logout"
    >
      退出登录
    </div> -->
  </div>
</template>
<script>
import ProductCouponWindow from "@components/ProductCouponWindow";
// import ProductWindow from "@components/ProductWindow";

import { getUser, getMenuUser, getLogout, getCouponsUser } from "@api/user";
import { isWeixin } from "@utils";
import SwitchWindow from "@components/SwitchWindow";
import UserOrder from "@components/UserOrder.vue";
import { clearAuthStatus, openScanQrcode } from "@libs/wechat";
import { switchH5Login } from "@api/user";
import cookie from "@utils/store/cookie";
import store from "@/store";
import dayjs from "dayjs";
import { islogin, getUserInfo } from '../../api/user';
import { mapGetters } from "vuex";
import { Icon, Button } from "vant";
const NAME = "User";

export default {
  name: NAME,
  components: {
    SwitchWindow,
    ProductCouponWindow,
    UserOrder,
    Icon,
    Button
    // ProductWindow
  },
  props: {},
  data: function () {
    return {
      movieOrderInfo: { //电影订单信息
        title: "电影订单",
        goToUrl: "/movieOrder/3",
        list: [
          {
            goToUrl: {
              path: '/movieOrder/3'
            },
            img: require('../../assets/images/kabao1.png'),
            number: 0,
            title: "全部订单",
            name: "order_count"
          }, {
            goToUrl: {
              path: '/movieOrder/1'
            },
            img: require('../../assets/images/kabao.png'),
            number: 0,
            title: "待付款",
            name: "unpaid_count"
          }, {
            goToUrl: {
              path: '/movieOrder/2'
            },
            img: require('../../assets/images/daka1.png'),
            number: 0,
            title: "已完成",
            name: "complete_count"
          }
        ]
      },
      xkycOrderInfo: { //电影订单信息
        title: "演出订单",
        goToUrl: "/xkYcOrderList/3",
        list: [
          {
            goToUrl: {
              path: '/xkYcOrderList/3'
            },
            img: require('../../assets/images/kabao1.png'),
            number: 0,
            title: "全部订单",
            name: "order_count"
          }, {
            goToUrl: {
              path: '/xkYcOrderList/1'
            },
            img: require('../../assets/images/kabao.png'),
            number: 0,
            title: "待付款",
            name: "unpaid_count"
          }, {
            goToUrl: {
              path: '/xkYcOrderList/2'
            },
            img: require('../../assets/images/daka1.png'),
            number: 0,
            title: "已完成",
            name: "complete_count"
          }
        ]
      },
      ticketOrderInfo: { //门票订单信息
        title: "门票订单",
        goToUrl: "/ticketOrders/0",
        list: [
          {
            goToUrl: {
              path: '/ticketOrders/0'
            },
            img: require('../../assets/images/kabao1.png'),
            number: 0,
            title: "全部订单",
            name: "order_count"
          }, {
            goToUrl: {
              path: '/ticketOrders/1'
            },
            img: require('../../assets/images/kabao.png'),
            number: 0,
            title: "待付款",
            name: "unpaid_count"
          }, {
            goToUrl: {
              path: '/ticketOrders/2'
            },
            img: require('../../assets/images/daka.png'),
            number: 0,
            title: "已付款",
            name: "complete_count"
          }
        ]
      },
      cakeOrderInfo: {
        title: "蛋糕订单",
        goToUrl: "/cakeOrder/3",
        list: [
          {
            goToUrl: {
              path: '/cakeOrder/2'
            },
            img: require('../../assets/images/kabao1.png'),
            number: 2,
            title: "待付款",
            name: "unpaid_count"
          }, {
            goToUrl: {
              path: '/cakeOrder/3'
            },
            img: require('../../assets/images/kabao.png'),
            number: 3,
            title: "已付款",
            name: "unshipped_count"
          },  {
            goToUrl: {
              path: '/cakeOrder/4'
            },
            img: require('../../assets/images/daka.png'),
            number: 4,
            title: "已发货",
            name: "received_count"
          },{
            goToUrl: {
              path: '/cakeOrder/5'
            },
            img: require('../../assets/images/daka1.png'),
            number: 5,
            title: "售后/退款",
            name: "refund_count"
          }
        ]
      },
      userInfo: {},
      MyMenus: [],
      orderStatusNum: {},
      movieOrderStatusNum: {},//电影
      crtipsOrderStatusNum:{},
      dgOrderStatusNum: {},//蛋糕
      xkycOrderStatusNum:{},//轩夸演出
      switchActive: false,
      isWeixin: false,
      couponsList: [],
      isOpen: false, //是否打开属性组件
      dontUse: 0,
      useCoupon: 0,
      uStatus:1,
      attr: {
        cartAttr: false,
        productAttr: [],
        productSelect: {},
      },
      couponsListLength: 0,
      cannot_purchase_goods: [ // 不能购买商品、门票，只能用于购买电影的点券
        { min: 80026683, max: 80027063 },
        // 测试↓
        { min: 80027183, max: 80027184 }
      ],
      outType:'',
      bindStatus:0,
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME || n.name === "FestivalUser" || n.name === "bookUser") {
        this.User();
        this.getCoupons();
      }
    }
  },
  mounted: function () {
    // console.log(store.state.app.token);
    this.User();
    this.MenuUser();
    this.isWeixin = isWeixin();
    this.getCoupons();
    getCouponsUser(0, 2).then(res => {
      console.log(res.data.length,"111");
      this.dontUse = res.data.length;
      
    });
    // getUser().then(res => {
    //   this.userInfo = res.data;
    //   console.log(this.userInfo);
    //   console.log(res.data);
    //   this.orderStatusNum = res.data.orderStatusNum;
    // });
    this.getUserInfo()
  },
  methods: {
    getCoupons: function () {
      getCouponsUser(0).then(res => {
        this.couponsList = res.data;
        this.couponsListLength = res.data.length;
        this.useCoupon = res.data.length;
        this.attr.productAttr = res.data;

        //
        this.isCannotP();
      });
    },
    isCannotP() {
      for (let i = 0; i < this.attr.productAttr.length; i++) {
        let card = this.attr.productAttr[i].coupon_title;
        for (let t = 0; t < this.cannot_purchase_goods.length; t++) {
          if (card >= this.cannot_purchase_goods[t].min && card <= this.cannot_purchase_goods[t].max) {
            if (card != 80026760 && card != 80026695 && card != 80027047 && card != 80026958 && card != 80026957) {
              this.attr.productAttr[i].isCannot = true;
            }
          }
        }
      }
    },
    getUserInfo() {
      getUserInfo().then(res => {
        this.uStatus=res.data.status
        this.bindStatus=res.data.bind_status
        console.log(this.bindStatus,"shabi");
        if (res.data.status==0) {
          this.$router.replace('/login')
        }
        this.outType = res.data.type
      })
    },
    scanQrcode: function () {
      openScanQrcode();
    },
    openZujian: function () {
      var that = this;
      this.getCoupons()
      that.attr.cartAttr = !that.attr.cartAttr;
    },
    changeattr: function (msg) {
      this.attr.cartAttr = msg;
      this.isOpen = false;
    },
    //将父级向子集多次传送的函数合二为一；
    changeFun: function (opt) {
      if (typeof opt !== "object") opt = {};
      let action = opt.action || "";
      let value = opt.value === undefined ? "" : opt.value;
      this[action] && this[action](value);
    },
    logout: function () {
      this.$dialog.confirm({
        mes: "确认退出登录?",
        opts: () => {
          // getLogout()
          //   .then(res => {
          //     this.$store.commit("LOGOUT");
          //     // clearAuthStatus();
          //     location.href = location.origin;
          //     // location.href = "/";
          //     console.log(res);
          //   })
          //   .catch(err => {
          //     console.log(err);
          //     location.href = location.origin;
          //   });
          islogin({ islogin: 2 })
            .then(res => {
              this.$store.commit("LOGOUT");
              clearAuthStatus()
              location.href = '/login';
              localStorage.removeItem("LOGIN")
              sessionStorage.removeItem('UID')
              sessionStorage.removeItem("OPID")
            })
            .catch(err => {
              location.href = '/login';
              clearAuthStatus()
              localStorage.removeItem("LOGIN")
              sessionStorage.removeItem('UID')
              sessionStorage.removeItem("OPID")
            });
        }
      });
    },
    switchAccounts: function (index) {
      let that = this;
      this.userIndex = index;
      let userInfo = this.switchUserInfo[this.userIndex];
      if (this.switchUserInfo.length <= 1) return true;
      if (userInfo === undefined)
        return this.$dialog.toast({ mes: "切换的账号不存在" });
      if (userInfo.user_type === "h5") {
        switchH5Login()
          .then(({ data }) => {
            that.$dialog.loading.close();
            const expires_time = dayjs(data.expires_time);
            store.commit("LOGIN", data.token, expires_time);
            that.$emit("changeswitch", false);
            location.reload();
          })
          .catch(err => {
            that.$dialog.loading.close();
            return that.$dialog.toast({ mes: err });
          });
      } else {
        cookie.set("loginType", "wechat", 60);
        this.$dialog.loading.close();
        this.$store.commit("LOGOUT");
        clearAuthStatus();
        this.$emit("changeswitch", false);
        location.reload();
      }
    },
    changeswitch: function (data) {
      this.switchActive = data;
    },
    User: function () {
      let that = this;
      let querys = (that.$route.query && that.$route.query.festivalName) || null;
      getUser({
        festival_type: querys
      }).then(res => {
        that.userInfo = res.data;
        // console.log(res.data);
        that.orderStatusNum = res.data.orderStatusNum;
        that.movieOrderStatusNum = res.data.movieOrderStatusNum;
        that.dgOrderStatusNum = res.data.dgOrderStatusNum;
        that.crtipsOrderStatusNum = res && res.data && res.data.crtipsOrderStatusNum;
         that.xkycOrderStatusNum=res.data.ycOrderStatusNum
        that.cakeOrderInfo.list.forEach((item, ind) => {
          item.number = that.dgOrderStatusNum[`${item.name}`];
        });
        //轩夸演出
        that.xkycOrderInfo.list.forEach((item, ind) => {
          item.number = that.xkycOrderStatusNum[`${item.name}`];
        });
        // 电影信息
        that.movieOrderInfo.list.forEach((item, ind) => {
          item.number = that.movieOrderStatusNum[`${item.name}`];
        });

        // 门票
        this.ticketOrderInfo.list.forEach((item, ind) => {
          item.number = this.crtipsOrderStatusNum[`${item.name}`];
        })

      });
    },
    MenuUser: function () {
      let that = this;
      getMenuUser().then(res => {
        that.MyMenus = res.data.routine_my_menus;
      });
    },
    goPages: function (index) {
      let url = this.MyMenus[index].wap_url;
      if (url === "/user/user_promotion" && this.userInfo.statu === 1) {
        if (!this.userInfo.is_promoter)
          return this.$dialog.toast({ mes: "您还没有推广权限！！" });
      }
      if (url === "/customer/index" && !this.userInfo.adminid) {
        return this.$dialog.toast({ mes: "您还不是客服！！" });
      }

      this.$router.push({ path: this.MyMenus[index].wap_url });
    }
  }
};
</script>

<style scoped>
.user {
  padding-bottom: 1.5rem;
}

.user-right-margin {
  margin-right: .1rem;
}

.footer-line-height {
  height: 1rem;
}

.order-status-num {
  min-width: 0.33rem;
  background-color: #fff;
  color: #ee5a52;
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 0.2rem;
  padding: 0 0.08rem;
  border: 1px solid #ee5a52;
}

.pictrue {
  position: relative;
}

.switch-h5 {
  margin-left: 0.2rem;
}

.binding {
  padding: 0.05rem 0.2rem;
  background-color: #ca1f10;
  border-radius: 50px;
  font-size: 0.14rem;
  border: 1px solid #e8695e;
  color: #ffffff;
}

.serviceList .item:first-child {
  display: none;
}

.num .gqcz {
  border-radius: 6px;
}

.ExchangeCertificate {
  width: 90%;
  height: 1.5rem;
  margin-left: 0.35rem;
  background: url(../../assets/images/userbg.png) no-repeat;
  background-position: center;
  display: flex;
  justify-content: space-between;
  padding: 0.3rem 0.3rem;
  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
}

::v-deep .van-button--small {
  height: 32px;
  padding: 0.3rem 0.3rem;
  font-size: 0.3rem;
}

.userExchange {
  font-size: 0.39rem;
  color: #F6433D;
  font-weight: 600;
}

.viewNow {
  margin-top: 0.2rem;
}

.huanjuan span {
  color: black;
  font-size: 0.3rem;
  font-weight: 300;
}

.huanjuan {
  margin-top: 0.1rem;
}

.iconWeizhi {
  font-size: 0.5rem;
  color: black;
  font-weight: 900;
}

.moneybalance {
  color: red;
}

.outLogin {
  width: 1.5rem;
  height: 0.5rem;
  background: #ee0a24;
  margin-left: 0.3rem;
  margin-top: 0.15rem;
  text-align: center;
  line-height: 0.5rem;
  border-radius: 0.25rem;
  color: white;
}
</style>
